import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteColor } from '../../api/COLORS/colors';
import { toast } from 'react-toastify';

export const useDeleteColor = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteColor,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['colors'] });
            toast.success('Couleur supprimée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la suppression de la couleur');
        },
    });
};
